import { Ebene } from './types/ebene';

export const SOFTLINE_FEATURE_PMS_ARBEITSBERICHT_STATISTIK = 'pmsArbeitsberichtStatistik';
export const SOFTLINE_FEATURE_PMS_ARBEITSBERICHT_STATISTIK_STUNDEN_UEBERSICHT_WIDGET = 'pmsArbeitsberichtStatistik.stundenUebersichtWidget';

export const SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK = 'ARBEITSBERICHTSTATISTIK';
export const SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK_STUNDEN_UEBERSICHT_WIDGET = 'ARBEITSBERICHTSTATISTIK.WIDGET_STUNDEN';
export const SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK_TICKET_UEBERSICHT_WIDGET = 'ARBEITSBERICHTSTATISTIK.WIDGET_TICKETS';

export const SOFTLINE_CONST_EBENEN: Ebene[] = [
  {
    id: 1,
    group: '1',
    kurzbez: 'Abteilung',
    queryKey: 'abteilungId'
  }, {
    id: 2,
    group: '2',
    kurzbez: 'Mitarbeiter',
    queryKey: 'lstfixId'
  }, {
    id: 3,
    group: '3',
    kurzbez: 'Objekt',
    queryKey: 'objectId'
  }, {
    id: 4,
    group: '4',
    kurzbez: 'Kostenstelle',
    queryKey: 'kstId'
  }, {
    id: 5,
    group: '5',
    kurzbez: 'Kunde',
    queryKey: 'ktostammId'
  }, {
    id: 6,
    group: '6',
    kurzbez: 'Kundengruppe',
  }, {
    id: 7,
    group: '7',
    kurzbez: 'Objektgruppe',
  }, {
    id: 8,
    group: '8',
    kurzbez: 'Leiter',
  }, {
    id: 9,
    group: '9',
    kurzbez: 'Einzeln',
  },
];
